import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import _, { isEmpty } from "lodash";
import { getUserByEmail, actualizarRegistro } from "../utils/Actions";
import { generatePasswordRand, sendEmail, validaremail } from "../utils/Utils";
import { ADMINEMAIL, getemail } from "../config/emails";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function RecoverPassword(props) {
  const classes = useStyles();
  const [state, setstate] = useState();
  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = useState(false);

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const { visible, setVisible } = props;

  const handleOpen = () => {
    setVisible(true);
    setOpen(true);
  };

  const handleClose = () => {
    setVisible(false);
    setOpen(false);
  };

  const _save = async () => {
    const { user } = state;

    if (isEmpty(user)) {
      alert("Debe ingresar su correo electrónico");
    } else if (!validaremail(user.trim())) {
      alert("Favor ingrese un correo electronico válido");
    } else {
      setloading(true);
      const resultado = await getUserByEmail(user.trim());
      let passwordweb = generatePasswordRand(6, "rand");
      let userweb = _.get(resultado, "data[0].userweb", "");
      let idusuario = _.get(resultado, "data[0].id", "");

      console.log(resultado);
      if (resultado.statusresponse) {
        await actualizarRegistro("Usuarios", idusuario, {
          passwordweb: passwordweb,
        });

        const asunto = encodeURIComponent(
          "Recuperar contraseña Sayeret Security"
        );

        const body = `Ha solicitado recuperar su contraseña en el sistema de Sayeret Security,  <br><br>Su usuario es: ${userweb} <br> Su nueva contraseña es: ${passwordweb} <br>Presione <a href="https://www.sayeretsecurity.net/" >Aquí</a> para ingresar a nuestra plataforma web. <br>`;

        const destino = encodeURIComponent(user.trim());

        const email = encodeURIComponent(body);

        await sendEmail(email, asunto, destino); // Descomentar eso cuando ya se defina
        alert(
          "Solicitud exitosa. Se ha enviado la información de inicio de sesión a su correo electrónico."
        );
        setVisible(false);
      } else {
        alert(
          "No existe un correo una cuenta asociado a este correo, favor verifique o contácte al administrador."
        );
      }
      setloading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={visible}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            RECUPERAR CONTRASEÑA{" "}
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Favor coloque su correo"
              name="user"
              autoComplete="email"
              autoFocus
              onChange={onChange}
              disabled={loading}
            />

            <Button
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
              onClick={_save}
              disabled={loading}
            >
              {loading ? (
                <Typography> FAVOR ESPERE </Typography>
              ) : (
                <Typography> RECUPERAR CONTRASEÑA </Typography>
              )}
            </Button>
            <Grid container>
              <Grid item xs>
                <br />
                <Link
                  onClick={() => {
                    setVisible(false);
                  }}
                  variant="body2"
                >
                  {"<<"} Regresar
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Modal>
    </Container>
  );
}
